import { render } from "./lstItems.vue?vue&type=template&id=28b618a6"
import script from "./lstItems.vue?vue&type=script&lang=ts"
export * from "./lstItems.vue?vue&type=script&lang=ts"
script.render = render

export default script